<template>
  <div class="full-sceen-tips" @click="remove">
    <v-mask></v-mask>
    <div class="horizontal-center container" ondragstart="return false;" v-html="html"></div>
  </div>
</template>

<script>
import vmask from "@/components/mask.vue";
export default {
  name: "fullSceenTips",
  components: {
    "v-mask": vmask,
  },
  data() {
    return {
      html: "",
    };
  },
  methods: {
    remove() {
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el);
      this.$destroy(true);
      window.__fullSceenTips = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.full-sceen-tips {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  .container {
    z-index: 301;
    top: 10%;
    width: 80%;
  }
}
</style>